var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReservationicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_187_1857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1875 9.25V11.5625H9.25V9.25H16.1875ZM9.25 16.1875V13.875H16.1875V16.1875H9.25ZM9.25 20.8125V18.5H13.875V20.8125H9.25ZM6.9375 9.25V11.5625H4.625V9.25H6.9375ZM6.9375 13.875V16.1875H4.625V13.875H6.9375ZM4.625 20.8125V18.5H6.9375V20.8125H4.625ZM2.3125 2.3125V34.6875H13.875V37H0V0H20.144L30.0625 9.91846V13.875H27.75V11.5625H18.5V2.3125H2.3125ZM20.8125 3.95654V9.25H26.106L20.8125 3.95654ZM32.375 18.5H37V37H16.1875V18.5H20.8125V16.1875H23.125V18.5H30.0625V16.1875H32.375V18.5ZM34.6875 34.6875V25.4375H18.5V34.6875H34.6875ZM34.6875 23.125V20.8125H18.5V23.125H34.6875Z",
    fill: "#FFA808"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_187_1857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationicon);
export default __webpack_public_path__ + "static/media/reservationicon.69f4c80196553a1f1abed163767863ab.svg";
export { ForwardRef as ReactComponent };